module.exports = {"version":"v1","limitedLocales":["es"]}